/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */

import { validateActionEvent } from './validateActionEvent';

export function validateTrackEvent(event: any): void {
	validateActionEvent(event);
}
